import { FC, useEffect, useState } from "react";
import "./CalendarPassLastStageThankYouScreen.css";
import { useNavigate } from "react-router-dom";
import allSetAnimation from "../../../assets/gif/pass-success-aniamtion.gif";
import allSetStar from "../../../assets/images/pass-success-icon.svg";
import appIcon from "../../../assets/images/header-sabehub-app-icon.svg";
import successEmoji from "../../../assets/images/payment-success-screen-success-emoji.svg";
import letsDoItIcon from "../../../assets/images/lets-do-it-icon.svg";
import calendarIcon from "../../../assets/images/calendar-pass-thanks-calendar-icon.svg";
import shareIcon from "../../../assets/images/calendar-pass-thank-you-share.svg";
import ROUTE_PATHS from "utils/routePaths";
import { highlightLastWord } from "utils/utils";

const CalendarPassLastStageThankYouScreen: FC = () => {
  const navigate = useNavigate();
  const [showGif, setShowGif] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowGif(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  const handleAllSetClick = () => {
    navigate(ROUTE_PATHS.WSM_HOME, { replace: true });
  };

  const handleShareClick = () => {};

  return (
    <div className="wms-mobile-container">
      <div className="calendar-pass-last-stage-thank-you-screen-detail-screen-container">
        <div className="calendar-pass-last-stage-thank-you-screen-header-sticky">
          <header className="calendar-pass-last-stage-thank-you-screen-header-bar">
            <img src={appIcon} alt="header-app-icon" />
            <div className="calendar-pass-last-stage-thank-you-screen-header-divider"></div>
            <span>{highlightLastWord("The Focus House")}</span>
          </header>
        </div>
        <div className="calendar-pass-last-stage-thank-you-screen-detail-screen-content-container">
          {showGif ? (
            <img
              src={allSetAnimation}
              alt="all-set-animation"
              className="animation-container"
            />
          ) : (
            <img
              src={allSetStar}
              alt="all-set-complete"
              className="animation-container"
            />
          )}
          <div className="you-are-in-container">
            <span>Thank You</span>
            <img src={successEmoji} alt="success-emoji-icon" />
          </div>
          <div className="description-container">
            <span>
              Thank You For Showing Up For Your Work Today, Focus Like This - Is
              A <span style={{ color: "#C1F700" }}>Rhythm </span> The More You
              Return, The More It Compounds.
            </span>
          </div>

          <div className="detail-container">
            <div className="content-container">
              <img src={calendarIcon} alt="calendar-icon" />
              <div className="right">
                <span className="title">Keep The Momentum Going</span>
                <span>Book your next session, or bring a friend along</span>
              </div>
            </div>
          </div>
          <div
            className="calendar-pass-last-stage-thank-you-screen-detail-next-btn"
            onClick={handleAllSetClick}
          >
            Book my next Focus House
            <img src={letsDoItIcon} alt="right-arrow-icon" />
          </div>
          <div
            className="calendar-pass-last-stage-thank-you-screen-detail-share-btn"
            onClick={handleShareClick}
          >
            Share With A Friend
            <img src={shareIcon} alt="right-arrow-icon" />
          </div>
          <span className="calendar-pass-last-stage-thank-you-screen-footer-text">
            See you at the next one.
          </span>
        </div>
      </div>
    </div>
  );
};

export default CalendarPassLastStageThankYouScreen;
